import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { ReportOrderComponent } from './report-order.component';

const routes : Routes=[
  {
    path:'',
    component:ReportOrderComponent
  }
]

@NgModule({
  imports:[RouterModule.forChild(routes)],
  exports:[RouterModule]
})
export class ReportOrderRoutingModule { }
